// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ar-3";
export var contentContainer = "_ar-0";
export var editorContainer = "_ar-1";
export var quillInputForm = "_ar-2";
export var zoneDivider = "_ar-4";